import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown'];
  static values = {
    projectId: String,
    fromColumnName: String,
  };

  connect() {
    const statusBadge = this.element.querySelector('.status-badge');
    if (statusBadge) {
      statusBadge.style.cursor = 'pointer';
      statusBadge.addEventListener('click', this.toggleDropdown.bind(this));
    }

    document.addEventListener('click', (event) => {
      if (!this.element.contains(event.target) && !this.dropdownTarget.classList.contains('hide')) {
        this.dropdownTarget.classList.add('hide');
      }
    });
  }

  toggleDropdown(event) {
    event.preventDefault();
    this.dropdownTarget.classList.toggle('hide');
  }

  async selectStatus(event) {
    event.preventDefault();

    const projectId = this.projectIdValue;
    const fromColumn = this.fromColumnNameValue;
    const toKanbanColumn = event.currentTarget.dataset.column_name;

    const response = await fetch(`/kanban/project/${projectId}/xhr_update_kanban_column`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ from_kanban_column: fromColumn, to_kanban_column: toKanbanColumn }),
    });

    if (!response.ok) {
      console.error('❌ Failed to update kanban column');
      return;
    }

    const statusContainer = document.querySelector('.status-container');
    const statusLink = statusContainer.querySelector('a');

    if (statusLink) {
      statusLink.textContent = toKanbanColumn
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    this.dropdownTarget.classList.add('hide');
  }
}
